import Settings from "../api/SettingsInstance"
import AuthInstance from '../api/ContextInstance';

var moment = require('moment');


export default {
  data() {
    return {
      contextChangeInProgress: false
    }
  },
  methods: {
    hasPermission(permissionId) {
      return this.$context.hasPermission(permissionId);
    },
    hasPermissionByRouteName(value) {
      let route = this.$router.options.routes.find(x => x.name === value);
      return this.hasPermissionByRoute(route);
    },
    hasPermissionByRoutePath(value) {
      let route = this.$router.options.routes.find(x => x.path === value || x.path === value + "/");
      return this.hasPermissionByRoute(route);
    },
    hasPermissionByRoute(route) {
      route = route || this.$route;
      return !!route && this.$context.hasPermissionByRequiredPermissionIds(route.meta.permissionIds);
    },
    changeContext(payload) {
      this.contextChangeInProgress = true;
      this.$context.changeContext(payload.organizationId)
      .then(_ => payload.then ? payload.then() : {})
      .catch(error => payload.catch ? payload.catch() : {})
      .finally(_ => this.contextChangeInProgress = false);
    }
  },
  computed: {
    authPermissions() {
      return AuthInstance.contextPermissions;
    },
    authReadonly() {
      return AuthInstance.readonly;
    },
    contextPermissions() {
      return this.$context.state.permissions;
    },
    contextEmail() {
      return this.$context.state.email;
    },
    contextOrganizations() {
      return this.$context.state.organizations;
    },
    contextOrganizationId() {
      return this.$context.state.organizationId;
    },
    contextForestryManagementName() {
      return this.$context.state.forestryManagementName;
    },
    contextTerytId() {
      return this.$context.state.terytId;
    },
    showSystemUnavailable() {
      return this.$context.state.systemUnavailable && !this.$context.hasPermission("System_unavailability_management");
    },
    showNoOrganization() {
      return this.$context.state.noOrganizations;
    },
    showNoRoles() {
      return this.$context.state.noRoles;
    },
    contextSystemUnavailableMessage() {
      return this.$context.state.systemUnavailableMessage;
    },
    contextSystemUnavailableEndDate() {
      if (this.$context.state.systemUnavailableEndDate) {
        return moment.unix(this.$context.state.systemUnavailableEndDate).format(Settings.dateTimeFormat);
      }
    },
    hasMapPortalAccess() {
      return this.hasPermission('Map_portal_access');
    },
    contextIsAnonymous() {
      return this.$context.state.isAnonymous;
    },
    havePermissions() {
      if (this.$context.state.permissions) {
        var anonymousPermissions = this.$context.getAnonymousePermissions();
        return [...this.$context.state.permissions].filter(
          permission => !anonymousPermissions.includes(permission)
        ).length > 0;
      }
      return false;
    }
  }
};
